import { createEvent, createStore, sample } from 'effector';
import { MessagesTypesT } from './types';

export const clearMessage = createEvent();
export const setMessage = createEvent<MessagesTypesT>();
export const $message = createStore<MessagesTypesT | null>(null);

sample({
  clock: setMessage,
  target: $message
});

sample({
  clock: clearMessage,
  fn: () => null,
  target: $message
});
